export const mobilePlans = {
    'without-forced-term': {
        '8-gb-plan': 'izzi movil 8',
        '15-gb-plan': 'izzi movil 15',
        'unlimited-plan': 'izzi movil comparte tus datos',
    },
    'with-forced-term': {
        '5-gb-plan': 'izzi_movil 5 12 meses',
        '8-gb-plan': 'izzi movil 8 12 meses',
        'unlimited-plan': 'izzi movil comparte tus datos 12 meses',
    },
};
